import React from 'react';
import { canBeCleared, findOrderByItem } from '@/utils/resultsHelper';
import { orderByColumns } from '@/constants/fields';
import SortedColumn from '@/components/table/SortedColumn';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AuditsSortedColumn = ({
  category,
  code,
  name,
  orderByColumnFindName,
}) => {
  const { orderBy, singleSorting } = Selectors.useAuditsSortedColumn({ category });
  const onOrderByColumn = Events.useToggleAuditsColumnOrderBy(category, { code });
  const orderByColumn = orderByColumns[orderByColumnFindName] || orderByColumns[name] || name;
  const orderByItem = findOrderByItem(orderBy, orderByColumn);
  const orderByDirection = orderByItem ? orderByItem.direction : null;

  return category ? (
    <SortedColumn
      name={name}
      canBeCleared={canBeCleared(orderBy, singleSorting)}
      sorted={!!orderByDirection}
      asc={orderByDirection === 'asc'}
      onClick={() => onOrderByColumn({ orderByColumn })}
    />
  ) : (<UnsortedColumn columnId={name} />);
};

export default AuditsSortedColumn;
